import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Edit2, KeyRound, Lock, MoreVertical, Unlock } from 'lucide-react';
import { useState } from 'react';

import type { UserStatus } from '@/shared/utils/format-status.js';

interface Props {
    status: UserStatus;
    isSelf: boolean;
    labels: { edit: string; block: string; unblock: string; resetPassword: string };
    onEdit: () => void;
    onBlock: () => void;
    onUnblock: () => void;
    onReset: () => void;
}

export function UserActionsMenu({ status, isSelf, labels, onEdit, onBlock, onUnblock, onReset }: Props) {
    const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

    const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setMenuAnchor(e.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const handleCloseAndExecute = (callback: () => void) => () => {
        handleMenuClose();
        callback();
    };

    return (
        <Box onClick={(e) => e.stopPropagation()}>
            <IconButton data-testid="user-actions-menu-trigger" size="small" onClick={handleMenuOpen}>
                <MoreVertical size={16} />
            </IconButton>
            <Menu anchorEl={menuAnchor} open={!!menuAnchor} onClose={handleMenuClose} PaperProps={{ sx: { width: 176 } }}>
                <MenuItem data-testid="user-actions-menu-edit" onClick={handleCloseAndExecute(onEdit)}>
                    <Edit2 size={14} />
                    <Box sx={{ ml: 1.5 }}>{labels.edit}</Box>
                </MenuItem>
                {!isSelf && status === 'ATIVO' && (
                    <MenuItem data-testid="user-actions-menu-block" sx={{ color: 'error.main' }} onClick={handleCloseAndExecute(onBlock)}>
                        <Lock size={14} />
                        <Box sx={{ ml: 1.5 }}>{labels.block}</Box>
                    </MenuItem>
                )}
                {!isSelf && status === 'BLOQUEADO' && (
                    <MenuItem data-testid="user-actions-menu-unblock" sx={{ color: 'success.main' }} onClick={handleCloseAndExecute(onUnblock)}>
                        <Unlock size={14} />
                        <Box sx={{ ml: 1.5 }}>{labels.unblock}</Box>
                    </MenuItem>
                )}
                <MenuItem data-testid="user-actions-menu-reset" onClick={handleCloseAndExecute(onReset)}>
                    <KeyRound size={14} />
                    <Box sx={{ ml: 1.5 }}>{labels.resetPassword}</Box>
                </MenuItem>
            </Menu>
        </Box>
    );
}
